<!-- <template>
  <div style="width: 200px;;">
    <template v-for="(lang, key) in langs">
      <span :key="lang.flags" style="width: 45px; cursor: pointer; height: 45px; margin: 0px 5px;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span>
    </template>
  </div>
</template> -->

<!-- 드롭 다운으로 바꾸기 -->
<template>
  <div>
    <template>
      <a class="nav-link dropdown mr-4" href="javascript:void(0)" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="flag-icon" :class="flags(lang)" style="width: 30px; cursor: pointer; height: 30px;"></span>
      </a>
      <ul class="dropdown-menu notif-box animated fadeIn mr-4" aria-labelledby="notifDropdown" style="width:100px;">
        <li>
          <div class="notif-center" v-for="(lang, key) in langs" @click="setLang(key)">
            <a href="javascript:void(0)">
              <div class="notif-icon">
                <span :key="lang.flags" style="width: 30px; cursor: pointer; height: 30px; margin: 0px 5px;" class="flag-icon" :class="flags(lang.flags)" @click="setLang(key)"></span>
              </div>
              <div class="notif-content ml-3" v-if="current_lang == 'EN'">
                <span class="block" style="font-size : 1em;" v-if="key == 'EN'">{{lang ? 'English' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'KO'">{{lang ? 'Korean' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'JP'">{{lang ? 'Japanese' : ''}}</span>
              </div>
              <div class="notif-content ml-3" v-else-if="current_lang == 'KO'">
                <span class="block" style="font-size : 1em;" v-if="key == 'EN'">{{lang ? '영어' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'KO'">{{lang ? '한국어' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'JP'">{{lang ? '일본어' : ''}}</span>
              </div>
              <div class="notif-content ml-3" v-else-if="current_lang == 'JP'">
                <span class="block" style="font-size : 1em;" v-if="key == 'EN'">{{lang ? '英語' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'KO'">{{lang ? '韓国語' : ''}}</span>
                <span class="block" style="font-size : 1em;" v-if="key == 'JP'">{{lang ? '日本語' : ''}}</span>
              </div>
            </a>
            <div class="dropdown-divider"></div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.css';

import { SetLang, GetLang, LangStatus } from '@/f1/service/i18n'
export default {
  data: () => ({ langs : [], current_lang : '', lang : '' }),
  // data: () => ({ langs : []}),
  methods: {
    setLang(lang) { SetLang(lang); },
    flags(lang) {return `flag-icon-${lang.toLowerCase()}`; },
    load(){
      this.current_lang = LangStatus;

      // ko -> kr / en -> us / jp -> jp
      let country = this.langs[this.current_lang].flags
      this.lang = country;
    },
  },
  mounted() {
    this.langs = GetLang();
    this.load();
  },
};
</script>
